// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).on('turbo:load', function() {
  $('.color-picker').spectrum({
    type: 'color', 
    showPalette: 'false'
  });
  
  $('.status-logger').mouseenter(function() {
    var menu_width = $('.status-menu select').outerWidth();
    $('.work-status-log').css({'width': menu_width + 'px'});
    $('.work-status-log').show();
  });
  
  $('.status-logger').mouseleave(function() {
    $('.work-status-log').hide();
  });
});


